import React, { useState } from "react";

// IMAGENES
import CardSubProducto from "./CardSubProducto";
const ListaProducto = ({ subProducts, titleProd }) => {
  const [productsFiltered, setProductsFiltered] = useState(null);

  const category = subProducts?.reduce(
    (acc, el) => ({
      ...acc,
      [el.category]: el,
    }),
    {}
  );

  const handleFilter = (cat) => {
    const filter = subProducts?.filter((prod) => prod?.category === cat);
    filter && setProductsFiltered(filter);
  };

  return (
    <>
      <div className="container-fluid flex-column d-flex align-items-center lista-productos">
        <div>
          <button onClick={() => setProductsFiltered(null)} className="button">
            TODOS
          </button>
          {category &&
            Object.keys(category).map((cat, index) => (
              <button
                key={index}
                onClick={() => handleFilter(cat)}
                className="button"
              >
                {cat}
              </button>
            ))}
        </div>
        <div className="lista-producto d-flex justify-content-center flex-wrap">
          {productsFiltered
            ? productsFiltered?.map((prod, index) => {
                {
                  if (prod?.visible === true) {
                    return (
                      <CardSubProducto key={index} prod={prod} titleProd={titleProd} />
                    );
                  }
                }
              })
            : subProducts?.map((prod, index) => {
                {
                  if (prod?.visible === true) {
                    return (
                     <CardSubProducto key={index} prod={prod} titleProd={titleProd} />
                    );
                  }
                }
              })}
        </div>
      </div>
    </>
  );
};
export default ListaProducto;
